var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.66699C17 7.34091 16.4732 6.06914 15.5355 5.13146C14.5979 4.19378 13.3261 3.66699 12 3.66699C10.6739 3.66699 9.40215 4.19378 8.46447 5.13146C7.52678 6.06914 7 7.34091 7 8.66699C7 14.5003 4.5 16.167 4.5 16.167H19.5C19.5 16.167 17 14.5003 17 8.66699Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4419 19.5C13.2954 19.7526 13.0851 19.9622 12.8321 20.1079C12.5791 20.2537 12.2922 20.3304 12.0003 20.3304C11.7083 20.3304 11.4214 20.2537 11.1684 20.1079C10.9154 19.9622 10.7051 19.7526 10.5586 19.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.85e12b7c942d93b36e7c6f089a5ac7ea.svg";
export { ForwardRef as ReactComponent };